import { generateActions } from "../generateActions";
import { eStuLopNamHocActionsObj } from './../../action-types/category/IStuLopNamHocActions';

export const lopNamHocActions = {
  ...generateActions(eStuLopNamHocActionsObj, "LOP_NAM_HOC"),
};
